import axios from 'axios';
import {installDiscussions} from '@/utils/discussions';
import {installSessionInterceptor} from '@/utils/sessionSecurity';
import Vue from 'vue';
import {BModal} from 'bootstrap-vue';
import {installRequestFulfillmentVersion} from './requestFulfillmentVersion';
import {
    CLIENT_VERSION_HEADER,
    getClientBuildVersion,
    isAppUpdateError,
} from './versionApi';
import {isUnexpectedApiHtml, reportConnectionFailure} from './connectionFailure';
import {showApiErrorDialog} from './apiErrorDialog';

const api = axios.create();
installDiscussions(api);
installRequestFulfillmentVersion(api);
api.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
Vue.component('b-modal', BModal);
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    config.headers = config.headers || {};

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }

    config.headers[CLIENT_VERSION_HEADER] = getClientBuildVersion();

    return config;
});

installSessionInterceptor(api);
api.interceptors.response.use(response => {
    if (!isUnexpectedApiHtml(response)) return response;
    const error = new Error('Unexpected HTML response from API');
    error.config = response.config;
    error.response = response;
    reportConnectionFailure(error);
    return Promise.reject(error);
}, (error) => {
    if (reportConnectionFailure(error) || !error.response) return Promise.reject(error);

    const data = error.response.data;
    const ignoreModal = error.config && error.config.ignoreModal;
    const requestUrl = error.config?.url || '';
    const urlParsed = requestUrl.split(`/`);
    const method = error.config && error.config.method;
    const isPut = method === `put`;
    const isPhotos = urlParsed[2] === `photos`;
    const isAddUsersToTelegram = isPut && urlParsed[2] === `telegram` && urlParsed[3] === `groups`;
    const isVersionMismatch = isAppUpdateError(error);
    if (![401, 409, 428].includes(error.response.status) && !isPhotos && !isAddUsersToTelegram && !ignoreModal && !isVersionMismatch) {
        const raw = typeof data === 'string' ? data : data && (data.msg || data.message || data.error);
        const message = typeof raw === 'string' && raw.trim()
            ? raw.trim().slice(0, 400) : 'Не удалось выполнить запрос. Повторите попытку позже.';
        showApiErrorDialog(message);
    }
    return Promise.reject(error);
});

export default api;
